export default {"src":"/_next/static/media/AMT.eef3f405.svg","height":18,"width":18};